import { useTranslation } from 'react-i18next'

/**
 * Tamarra-style reservation progress.
 * Step ids are translated at render. Index is 0-based.
 */
const TamarraBookingProgress = ({ steps, current = 0, ariaLabel }) => {
  const { t } = useTranslation()
  return (
    <ol className="tamarra-prog" aria-label={ariaLabel ?? t('shell.tamarra.stepsAria')}>
      {steps.map((stepId, i) => (
        <li
          key={`${stepId}-${i}`}
          className={i < current ? 'done' : i === current ? 'cur' : ''}
          aria-current={i === current ? 'step' : undefined}
        >
          <span>{i + 1}</span>
          <em>{t(`shell.tamarra.${stepId}`)}</em>
        </li>
      ))}
    </ol>
  )
}

export const TAMARRA_STEPS_TRANSFER = [
  'trip',
  'formalities',
  'travellers',
  'payment',
  'confirmation',
]

export const TAMARRA_STEPS_SPA = [
  'care',
  'formalities',
  'travellers',
  'payment',
  'confirmation',
]

export const TAMARRA_STEPS_CARTE = [
  'card',
  'formalities',
  'travellers',
  'payment',
  'confirmation',
]

export const TAMARRA_STEPS_CIRCUIT = [
  'rooms',
  'formalities',
  'travellers',
  'payment',
  'confirmation',
]

export const TAMARRA_STEPS_CIRCUIT_ALACARTE = [
  'circuit',
  'formalities',
  'travellers',
  'payment',
  'confirmation',
]

/** Drop formalities from a progress list when the product has no content for that step. */
export const withoutFormalitesStep = (steps = []) =>
  steps.filter((stepId) => stepId !== 'formalities')

export default TamarraBookingProgress
